import React from "react";
import { Tooltip } from "@nexthink/apollo-components";
import styled from "styled-components";
export const StyledTooltip = styled((props) => React.createElement(Tooltip, Object.assign({ variant: "base" }, props))).withConfig({ displayName: "StyledTooltip_APW-12103_productShell", componentId: "-1ap3pvu" })(({ theme }) => ({
    [`& > div`]: {
        borderColor: theme.colors.apolloColorBackgroundButtonPrimaryDefault,
        borderRadius: "2px",
    },
    [`& > span`]: {
        borderLeftColor: theme.colors.apolloColorBackgroundButtonPrimaryDefault,
        borderTopColor: theme.colors.apolloColorBackgroundButtonPrimaryDefault,
        top: "4px !important",
    },
    [`button:hover`]: {
        background: `${theme.colors.apolloColorBackgroundButtonPrimaryDefault} !important`,
        textDecoration: "underline",
    },
}));
//# sourceMappingURL=ActionTooltip.style.js.map